/**
 * The footer's secondary controls (participants, chat, join-info) collapse
 * into the more-menu once the footer itself is too narrow to hold them. This
 * is driven by a container query on the footer (`@container/meeting-footer` —
 * set in MeetingFooter for every form factor), whose width already accounts
 * for the 320px right panel, so a single threshold works whether or not the
 * panel is open and whether the footer is fullscreen, one-pane or docked.
 * These two helpers are the two sides of that handoff: a button hides exactly
 * where the more-menu trigger appears.
 *
 * Both classes must live INSIDE the footer container to resolve — so they go
 * on the footer's own buttons and on the more-menu trigger wrapper, NOT on the
 * menu items themselves (those are portaled to the document root, outside the
 * container, where the query would never match — they simply render whenever
 * the menu is open).
 *
 * NOTE: the full class strings are spelled out so Tailwind's scanner picks
 * them up — do not build them via interpolation.
 */

/** Hides a footer button once the footer is too narrow to hold it. */
export const getFooterButtonHiddenClass = () =>
    '@max-[720px]/meeting-footer:hidden';

/** Shows the more-menu trigger only once the footer's buttons have collapsed. */
export const getFooterMenuItemShownClass = () =>
    'hidden @max-[720px]/meeting-footer:flex';
